import React from "react";
import "./AboutSection.css";
// Reference to the images provided in the prompt steps
import aboutImage from "../assets3/Washing_Machine_Services.png"; 

const AboutSection = () => {
  return (
    <section className="ahas-about-section">
      <div className="ahas-about-container">
        
        {/* Header Block - Separated so it stays at the top */}
        <div className="ahas-about-header">
          <span className="ahas-about-tag">About Jay Ambe Washing Machine Services!</span>
          <h2 className="ahas-about-title">
            Trusted Washing Machine Service by Experienced Technicians
          </h2>
        </div>
        
        {/* Image Block - Controlled independently in the grid/flex layout */}
        <div className="ahas-about-media">
          <img 
            src={aboutImage} 
            alt="Jay Ambe Home Appliances Service Van" 
            className="ahas-main-img"
          />
        </div>

        {/* Text Block - Controlled independently */}
        <div className="ahas-about-text">
          <p>
            <strong>Jay Ambe Washing Machine Services</strong> is a trusted and professional service provider 
            offering dedicated <strong>Washing Machine Repair and Service</strong> in Surat. We understand 
            how vital a smoothly running laundry routine is to your daily life, which is why our <strong>experienced 
            technicians provide fast, reliable, and affordable repair solutions</strong> for all major 
            brands and configurations.
          </p>
          
          <p>
            Our team is highly skilled in handling all types of modern washing machines, including 
            <strong> top-load, front-load, and semi-automatic models</strong>. Whether you have a premium 
            inverter model or a standard multi-tub setup, we possess the comprehensive technical expertise to diagnose 
            and repair the unit safely on-site.
          </p>
          
          <p>
            We specialize in fixing common mechanical and electrical faults such as machines that are 
            <strong> not spinning, failing to drain water, vibrating Excessively, making loud grinding noises, leaking, 
            or failing to start entirely</strong>. Our experts pinpoint the root cause efficiently and get your appliance back 
            to flawless operation using dependable, high-quality components.
          </p>
          
          <p>
            At Jay Ambe Washing Machine Services, customer satisfaction is our absolute priority. We 
            offer <strong>same-day service, prompt doorstep visits, and highly transparent pricing</strong> so that you can 
            get your laundry appliances working properly again without any hidden fees or stress.
          </p>
          
          <p>
            If you are looking for an expert, dedicated Washing Machine Repair Service in Surat, 
            Jay Ambe Washing Machine Services is your one-stop solution. Our local, professional 
            technicians ensure careful handling, durable repairs, and total convenience right at your home.
          </p>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;